import styled from 'styled-components';
import { box } from '../../styles/helpers';

export default styled.button`
  display: block;
  ${p => box({ ...p, type: 'button' })}
  padding: 0;
  text-align: left;

  cursor: pointer;

  will-change: transform;
  transition: transform 100ms;

  &:focus,
  &:hover {
    outline: none;
    transform: scale(1.1);
  }

  &[disabled] {
    cursor: not-allowed;
  }
`;
